var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8203 28L20.8203 20M14.1536 9.33333V17.3333M10.1536 13.3333H18.1537M23.487 13.3333C23.487 15.1793 22.9396 16.9838 21.914 18.5187C20.8885 20.0535 19.4308 21.2498 17.7254 21.9562C16.0199 22.6626 14.1433 22.8475 12.3328 22.4873C10.5223 22.1272 8.85928 21.2383 7.55399 19.933C6.2487 18.6277 5.35978 16.9647 4.99965 15.1542C4.63953 13.3437 4.82436 11.4671 5.53077 9.76162C6.23719 8.05618 7.43347 6.59851 8.96833 5.57295C10.5032 4.54739 12.3077 4 14.1536 4C16.629 4 19.003 4.98333 20.7533 6.73367C22.5037 8.48401 23.487 10.858 23.487 13.3333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.ee351659f0023226cbdb4182d7866dfb.svg";
export { ForwardRef as ReactComponent };